import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-78d21a54"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item-icon"
}, [/*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32",
  width: "32",
  height: "32",
  fill: "none"
}, [/*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M16.356 8.103c1.331 0 3-.896 3.994-2.089.9-1.082 1.556-2.592 1.556-4.103 0-.205-.018-.41-.056-.578-1.481.056-3.263.989-4.331 2.238-.844.951-1.613 2.443-1.613 3.972 0 .224.038.448.056.522.094.019.244.038.394.038ZM11.67 30.667c1.819 0 2.625-1.213 4.893-1.213 2.307 0 2.813 1.175 4.838 1.175 1.988 0 3.319-1.827 4.575-3.617 1.406-2.052 1.987-4.066 2.025-4.159-.131-.037-3.938-1.585-3.938-5.93 0-3.767 3-5.464 3.17-5.594-1.988-2.835-5.007-2.91-5.832-2.91-2.231 0-4.05 1.343-5.194 1.343-1.237 0-2.868-1.268-4.8-1.268C7.731 8.494 4 11.515 4 17.221c0 3.544 1.388 7.292 3.094 9.716 1.462 2.051 2.737 3.73 4.575 3.73Z"
})])], -1));
const _hoisted_2 = {
  class: "item-content"
};
const _hoisted_3 = {
  class: "text"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "name"
}, "App Store", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item-icon"
}, [/*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32",
  width: "32",
  height: "32",
  fill: "none"
}, [/*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "m27.083 17.118-4.857 2.776-3.774-3.904 3.767-3.9 4.865 2.771c1.084.617 1.084 1.637-.001 2.257ZM21.022 11.409 6.072 2.906a1.673 1.673 0 0 0-.45-.188L17.525 15.03l3.497-3.622ZM16.598 15.99 4.21 3.175c-.133.241-.209.56-.209.934v23.764c.003.385-.082.7-.22.939l12.378-12.82ZM5.62 29.28c.159-.04.312-.105.454-.193l14.956-8.512-3.504-3.625L5.62 29.28Z"
})])], -1));
const _hoisted_6 = {
  class: "item-content"
};
const _hoisted_7 = {
  class: "text"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "name"
}, "Google Play", -1));
import { useI18n } from 'vue-i18n';
export default {
  __name: 'CusomDownload',
  props: {
    type: {
      type: Number,
      default: 0
    }
  },
  setup(__props) {
    const props = __props;
    const {
      t
    } = useI18n();
    const download = () => {
      //网页链接合成
      let address = '';
      let arr = window.location.host.split('.');
      if (arr.length == 3 && arr[0] == 'pc') {
        address = arr[1] + '.' + arr[2];
      } else if (arr.length == 3 && arr[0] == 'www') {
        address = arr[1] + '.' + arr[2];
      } else {
        address = arr[0] + '.' + arr[1];
      }
      window.open('https://' + address + '/FTZINC.apk');
    };
    const download1 = () => {
      //   网页链接合成
      let address = '';
      let arr = window.location.host.split('.');
      if (arr.length == 3 && arr[0] == 'pc') {
        address = arr[1] + '.' + arr[2];
      } else if (arr.length == 3 && arr[0] == 'www') {
        address = arr[1] + '.' + arr[2];
      } else {
        address = arr[0] + '.' + arr[1];
      }
      window.open('https://' + address + '/download/FTZCOIN.mobileconfig');
      // window.location.href = 'https://apps.apple.com/us/app/ftzc/id6759857278';
    };

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["custom-download", {
          'footer-version': props.type == 1
        }])
      }, [_createElementVNode("div", {
        class: "item",
        onClick: download1
      }, [_hoisted_1, _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('downloadOn')), 1), _hoisted_4])]), _createElementVNode("div", {
        class: "item",
        onClick: download
      }, [_hoisted_5, _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)('getItOn')), 1), _hoisted_8])])], 2);
    };
  }
};